import type { ReactNode } from 'react'

/**
 * Empty stub module for non-demo builds.
 * Vite aliases @/demo/runtime to this file unless VITE_INCLUDE_DEMO=true.
 * That keeps the real demo runtime out of normal bundles.
 */
export interface DemoModeProviderProps {
  children: ReactNode;
}

export const DemoModeProvider = ({ children }: DemoModeProviderProps) => children

export default DemoModeProvider
